import { OrderApi } from '@/plugins/api'
import alert from '@/plugins/alert'

export default {
  namespaced: true,
  state: {
    orders: [],
    order: {},
    cart: [],
    orderWithProducts: [],
    count: 0,
  },
  actions: {
    async createOrder(_, data) {
      const res = await OrderApi.create({ ...data })
      return res
    },
    async fetchOrders({ commit }, params) {
      const res = await OrderApi.fetch({ ...params })
      commit('setOrders', res)
      return res
    },
    async fetchOrder({ commit }, id) {
      const res = await OrderApi.fetchWithProduct(id)
      commit('setOrder', res)
      return res
    },
    addToCart({ commit }, book) {
      commit('addToCart', book)
    },
    removeBookFromCart({ commit }, bookId) {
      commit('removeBookFromCart', bookId)
    },
    reset({ commit }) {
      commit('reset')
    },
    async checkoutOrder(_, data) {
      await OrderApi.updateOrderPayment(data)
    },
    async updatePayment(_, data) {
      await OrderApi.payment(data)
    },
    setOrderIndependence({ commit }, data) {
      commit('setOrderIndependence', data)
    },
    async fetchOrderWithProducts({ commit }, params) {
      const res = await OrderApi.getLibraryOrder({ ...params })
      commit('getOrderWithProducts', res)
    },
    async completeOrder(_, id) {
      await OrderApi.completeOrder(id)
    },
    async completePartialBookOrder(_, data) {
      await OrderApi.completePartialBookOrder(data)
    },
    async countOrders({ commit }, params) {
      const res = await OrderApi.count(params)
      commit('setCount', res)
    },
  },
  mutations: {
    setOrders(state, payload) {
      state.orders = payload
    },
    setOrder(state, payload) {
      state.order = payload
    },
    addToCart(state, book) {
      const index = state.cart.findIndex((v) => v._id === book._id)
      if (index === -1) state.cart.push(book)
      else return alert.error('Sách đã tồn tạo trong giỏ hàng')
    },
    removeBookFromCart(state, bookId) {
      const index = state.cart.findIndex((v) => v._id === bookId)
      if (index > -1) state.cart.splice(index, 1)
    },
    reset(state) {
      state.cart = []
      state.order = {}
    },
    setOrderIndependence(state, data) {
      state.order = data
    },
    getOrderWithProducts(state, payload) {
      state.orderWithProducts = payload
    },
    setCount(state, payload) {
      state.count = payload
    },
  },
}
